// Sticky header: EN / ID · logogram (scroll to top) · A / A+ / A++ · chapter
// tab strip · 2 px gold progress hairline. Tone (night / day) and the active
// tab are decided by the scroll engine from the section under the header.
// Port of prototype lines 49–65.
import { TABS } from './data/adapt.js';

const mono = { fontFamily: "'DM Mono', 'DM Mono Fallback', ui-monospace, monospace" };
const btn = { minWidth: 44, height: 44, display: 'grid', placeItems: 'center', textUnderlineOffset: 5, textDecorationThickness: 1 };

export default function Header({ T, lang, setLang, fs, setFs, night, tab, hdBg, engine }) {
  const ink = night ? '#f4f0e8' : '#1F140E';
  // The engine hands over the colour of the section under the header, at 88 %,
  // so the bar melts into cream, teal, espresso dark or food green. It sends
  // null while a scene photo is still pinned — then the night wash applies.
  const bg = hdBg || (night ? 'rgba(7,30,33,.55)' : 'rgba(245,243,235,.86)');
  const rule = night ? 'rgba(244,240,232,.18)' : 'rgba(31,20,14,.14)';
  const numColor = night ? '#e8b86b' : '#8E4422';
  const line = night ? '#e8b86b' : '#1F140E';
  const divider = night ? 'rgba(244,240,232,.22)' : 'rgba(31,20,14,.18)';
  const deco = (on) => (on ? 'underline' : 'none');

  return (
    <div
      data-hd
      style={{ position: 'sticky', top: 0, zIndex: 5, color: ink, background: bg, backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)', transition: 'color .4s ease, background-color .4s ease' }}
    >
      <span data-prog aria-hidden="true" style={{ position: 'absolute', left: 0, bottom: 0, height: 2, width: '100%', transformOrigin: '0 50%', transform: 'scaleX(0)', background: '#e8b86b', willChange: 'transform', pointerEvents: 'none' }} />
      <div style={{ height: 56, display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', padding: '0 8px' }}>
        <div style={{ display: 'flex', justifySelf: 'start', ...mono, fontSize: 11, letterSpacing: '.1em' }} aria-label="Language">
          <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} style={{ ...btn, textDecoration: deco(lang === 'en') }}>EN</button>
          <button type="button" onClick={() => setLang('id')} aria-pressed={lang === 'id'} style={{ ...btn, textDecoration: deco(lang === 'id') }}>ID</button>
        </div>
        <button type="button" onClick={() => engine.goSection('s-top')} aria-label="Salésol — top" style={{ height: 44, width: 44, display: 'grid', placeItems: 'center' }}>
          <svg viewBox="0 0 1000 1000" width="28" height="28" aria-hidden="true"><use href="#salesol-mark" /></svg>
        </button>
        <div style={{ display: 'flex', justifySelf: 'end', ...mono, letterSpacing: '.04em' }} aria-label="Text size">
          <button type="button" onClick={() => setFs(16)} aria-pressed={fs === 16} style={{ ...btn, fontSize: 11, textDecoration: deco(fs === 16) }}>A</button>
          <button type="button" onClick={() => setFs(18)} aria-pressed={fs === 18} style={{ ...btn, fontSize: 12, textDecoration: deco(fs === 18) }}>A+</button>
          <button type="button" onClick={() => setFs(20)} aria-pressed={fs === 20} style={{ ...btn, fontSize: 13, textDecoration: deco(fs === 20) }}>A++</button>
        </div>
      </div>
      <nav
        data-strip
        aria-label="Chapters"
        style={{ display: 'flex', gap: 18, padding: '0 20px', height: 44, alignItems: 'stretch', boxSizing: 'content-box', overflowX: 'auto', whiteSpace: 'nowrap', ...mono, fontSize: '.6875em', letterSpacing: '.1em', textTransform: 'uppercase', borderBottom: `1px solid ${rule}` }}
      >
        {TABS.map(([id, num, sec, first], i) => {
          const on = tab === id;
          return (
            <button
              key={id}
              type="button"
              data-cat={id}
              aria-current={on ? 'true' : undefined}
              onClick={() => engine.goSection(sec, id === 'sig' || id === 'filter')}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 9, minWidth: 44, flex: 'none', boxSizing: 'border-box', paddingLeft: first && i > 0 ? 18 : 0, borderLeft: first && i > 0 ? `1px solid ${divider}` : 0, borderBottom: `2px solid ${on ? line : 'transparent'}`, color: 'inherit' }}
            >
              {num ? <span style={{ fontSize: '.82em', letterSpacing: '.06em', color: numColor }}>{num}</span> : null}
              {T.tabs[id]}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
